import * as React from "react";
import { observer } from "mobx-react";
import { CampaignRecommendationsWithOffersQuery } from "../../../../../../__generated__/api";
import Price = CampaignRecommendationsWithOffersQuery.Price;
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { InfoDialog } from "../../Common/InfoDialog/InfoDialog";
import { useLocalization } from "@shared-ui/localization-context";

export const DestinationOfferPriceInfo = observer(
  ({
    scrimDisplay,
    offerPrice,
    cardIndex,
    campaignId,
    openDialog,
    closeDialog,
  }: {
    scrimDisplay: boolean;
    offerPrice: Price;
    cardIndex: number;
    campaignId: string;
    openDialog: (dialogPath: string) => void;
    closeDialog: () => void;
  }) => {
    const valueClass = scrimDisplay
      ? "all-l-margin-one uitk-type-heading-500 cardContent"
      : "all-l-margin-one uitk-type-heading-600 ";
    const qualifierClass = scrimDisplay
      ? "all-l-margin-one uitk-type-paragraph-200 cardContent"
      : "all-l-margin-one uitk-type-100 ";
    const prefixClass = qualifierClass;

    const { formatText } = useLocalization();

    return (
      <div className="DestinationOfferPriceInfo">
        {offerPrice.prefixText && <div className={prefixClass}>{offerPrice.prefixText}</div>}
        {offerPrice.disclaimerText && (
          <button
            className="disclaimerInfoIcon"
            onClick={openDialog.bind(this, `disclaimer-info-${campaignId}-${cardIndex}`)}
          >
            <UitkIcon
              name="info_outline"
              size={UitkIconSize.SMALL}
              id={`disclaimer-info-${campaignId}-${cardIndex}`}
              title={formatText("merchCampaign.disclaimerIcon.title")}
            />
          </button>
        )}
        <span className={valueClass}>{offerPrice.value}</span>
        <div className={qualifierClass}>{offerPrice.qualifierText}</div>
        {offerPrice.disclaimerText && (
          <QueryRoute query={{ pwaDialog: `disclaimer-info-${campaignId}-${cardIndex}` }}>
            <Layer id={`disclaimer-info-dialog-${campaignId}-${cardIndex}`} onDismiss={closeDialog}>
              <InfoDialog
                infoText={offerPrice.disclaimerText}
                closeDialog={closeDialog}
                buttonText={formatText("DestinationsByAffinity.priceDialogCloseButton")}
              />
            </Layer>
          </QueryRoute>
        )}
      </div>
    );
  }
);
